export default "__VITE_ASSET__qcbOD8O0__"